import { useTranslation } from "react-i18next";

export default function RegisterAccountCrumb(): string {
  const { t } = useTranslation();
  return t("crumb.RegisterAccount");
}
